import React, { lazy, Suspense } from 'react';
import { ActivityIndicator, View } from 'react-native';
import { Stack, useRouter } from 'expo-router';
import { useAuthStore, useModalStore } from '@/store';
import { useTheme } from '@/context/ThemeContext';
import { useTranslation } from '@/hooks/useTranslation';
import Text from '@/components/Typography/Text';
import Button from '@/components/Buttons/Button';

const SettingsPage = lazy(() => import('@/components/Settings/SettingsPage'));

export default function SettingsRoute() {
  const router = useRouter();
  const { colors } = useTheme();
  const { t } = useTranslation();
  const token = useAuthStore(state => state.token);
  const isTokenExpired = useAuthStore(state => state.isTokenExpired);
  const { openModal } = useModalStore(state => state.actions);
  const authenticated = !!token && !isTokenExpired();
  return <View style={{ flex: 1, backgroundColor: colors.solid_color_primary }}>
    <Stack.Screen options={{ headerShown: false, title: t('settingsPage.title') }} />
    {authenticated ? <Suspense fallback={<ActivityIndicator style={{ flex: 1 }} color={colors.text_color_primary} />}><SettingsPage /></Suspense> :
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', padding: 24, gap: 16 }}>
        <Text size="xxl" weight="bold">{t('settingsPage.signInTitle')}</Text>
        <Text color="secondary" style={{ textAlign: 'center', maxWidth: 400 }}>{t('settingsPage.signInDescription')}</Text>
        <Button text={t('settingsPage.signIn')} onPress={() => openModal('AuthCTAModal', { source: 'settings_route' })} />
        <Button variant="secondary" text={t('settingsPage.back')} onPress={() => router.canGoBack() ? router.back() : router.replace('/app')} />
      </View>}
  </View>;
}
